<template>
    <div class="mobile-news-item">
    <a :href="'/post/' + news.uid + '.html'" target="_blank" style="text-decoration: none; display: block;">

        <div class="left-content">
            <div class="main-title">
                {{ news.title.length > 40 ? news.title.substring(0,40) + '...' : news.title }}
            </div>
            <div class="bottom-info">
                <div class="tag">
                </div>
                <div class="auther-info">
                    <div class="name">
                        {{ news.author.name }}
                    </div>
                    <div class="time">
                        {{ timeAgo(news.time) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="right-image">
           <img :src="news.photo">
        </div>
    </a>
    </div>
</template>

<script>
import moment from 'moment'

moment.locale('en', {
    relativeTime : {
        future: "%s后",
        past:  "%s前",
        s:  "秒",
        m:  "1 分钟",
        mm: "%d 分钟",
        h:  "1 小时",
        hh: "%d 小时",
        d:  "1 天",
        dd: "%d 天",
        M:  "1 个月",
        MM: "%d 月",
        y:  "1 年",
        yy: "%d 年"
    }
});

export default{
    props:['news'],
    methods:{
        timeAgo(time){
           return  moment(time).fromNow()
        }
    }
}
</script>

<style lang="scss">
.mobile-news-item{
    width: 95%;
    margin: 0 auto;
    border-bottom: 1px solid #ededed;
    padding: 14px 0;
    .right-image{
        display: inline-block;
        img{
            max-width: .9rem;
        }
    }
    .left-content{
        width: 70%;
        display: inline-block;
        vertical-align: top;
        padding: 0 14px;
        .main-title{
            height: .64rem;
            font-size: .13rem;
            color: #212121;
        }
        .bottom-info{
            // height: .3rem;
            // line-height: .3rem;
            .tag{
                display: inline-block;
                color:#5a86da;
            }
            .auther-info{
                display: inline-block;
                color: #878787;
                .name{
                    display: inline-block;
                }
                .time{
                    display: inline-block;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// MobileNewsItem.vue?231d7452